/* ============
 * CurrencyTransformer
 * ============
 *
 * The transformer for the currency.
 */

import Transformer from './transformer';

export default class currencyTransformer extends Transformer {

  static fetch(currency) {
    return {
      id: currency.id,
      name: currency.name,
      code: currency.code,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/currency.js